module.exports = __webpack_public_path__ + "static/media/P8.f6ad41b3.png";